import * as React from 'react';
import { Box, Flex, Heading, Text } from 'core/components';
import CloudIcon from 'app/views/hybrid/maps/components/CloudIcon';
import { ENTITY_TYPES } from '@kentik/ui-shared/hybrid/constants';
import CloudDetailLink from 'app/components/links/CloudDetailLink';
import CloudMetadata from 'app/views/hybrid/maps/components/popovers/CloudMetadata';
import SidebarItem from 'app/views/hybrid/maps/components/popovers/SidebarItem';

const { VIRTUAL_CIRCUIT } = ENTITY_TYPES.get('oci');

const VirtualCircuitSummary = (config) => {
  const { value, cloudProvider, nodeData } = config;

  const cloudMetadataDetails = {
    node: {
      ...nodeData,
      ID: nodeData.id,
      Name: nodeData.displayName,
      'Gateway ID': nodeData.gatewayId,
      'Created At': new Date(nodeData.timeCreated).toLocaleString()
    },
    keys: [
      ...new Set(
        Object.keys(nodeData)
          .filter((key) => ['displayName', 'gatewayId', 'crossConnectMappings'].includes(key) === false)
          // add on top of the array
          .concat(['Created At', 'Gateway ID', 'Region', 'Tenancy ID', 'Name', 'ID', 'Type'])
          .reverse()
      )
    ]
  };

  return (
    <Box>
      <Flex borderBottom="thin" p={2} alignItems="center">
        <CloudIcon cloudProvider={cloudProvider} entity={VIRTUAL_CIRCUIT} width={32} height={32} />
        <Box flex={1} ml={1}>
          <Text as="div" muted>
            Cloud Virtual Circuit Details
          </Text>
          <Heading mb={0} level={4}>
            <CloudDetailLink cloud={cloudProvider} detail="virtualCircuit" value={value}>
              {nodeData.displayName}
            </CloudDetailLink>
          </Heading>
        </Box>
      </Flex>
      {nodeData && (
        <SidebarItem title="Details" icon="more" popoutTitle={VirtualCircuitSummary.PopoutTitle(config)}>
          <CloudMetadata {...cloudMetadataDetails} />
        </SidebarItem>
      )}
    </Box>
  );
};

VirtualCircuitSummary.PopoutTitle = (config) => {
  const { cloudProvider, nodeData } = config;

  return (
    <Flex alignItems="center">
      <CloudIcon cloudProvider={cloudProvider} entity={VIRTUAL_CIRCUIT} />
      <Box ml={1}>{`${nodeData.displayName} Virtual Circuit`}</Box>
    </Flex>
  );
};

export default VirtualCircuitSummary;
